var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"mousemove":_vm.handleTooltipMove,"mouseleave":_vm.hideTooltip}},[_c('router-view'),(_vm.tooltip.visible)?_c('div',{staticClass:"hf-floating-tooltip",style:(_vm.tooltipStyle)},[_vm._v(" "+_vm._s(_vm.tooltip.text)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }